import Vue from 'vue';
import Router from 'vue-router';


Vue.use(Router);

const routes = [{
		path: '/redirect/:path*',
		component: () => import('@/view/redirect/index')
	},
	{
		path: '/',
		component: () =>
			import('@/view/index/index'),
		meta: {
			title: '首页',
		}
	},
	
	// 画列表
	{
		path: '/hua/list',
		component: () =>
			import('@/view/hua/list'),
		meta: {
			title: '',
		}
	},
	{
		path: '/hua/chapterlist',
		component: () =>
			import('@/view/hua/chapterlist'),
		meta: {
			title: '',
		}
	},
	{
		path: '/hua/detail',
		component: () =>
			import('@/view/hua/detail'),
		meta: {
			title: '详情',
		}
	},

	// 浏览历史
	{
		path: '/history/index',
		component: () =>
			import('@/view/history/index'),
		meta: {
			title: '浏览历史',
		}
	},


];

// add route path
routes.forEach(route => {
	route.path = route.path || '/' + (route.name || '');
});


const router = new Router({
	// mode: 'history',
	routes,

	scrollBehavior(to, from, savedPosition) {
		if (!savedPosition) {
			return {
				x: 0,
				y: 0
			}
		}
	}
});


export {
	router
};
